import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, provide, reactive, inject } from 'vue'
import Move from './newCheckstand/move/Index.vue'
import Pc from './newCheckstand/pc/Index.vue'
import type { RespOrder } from '@/http/api/checkstand/types'
import { getOrderInfo } from '@/http/api/checkstand'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewHome',
  setup(__props) {

const orderInfo = reactive<RespOrder>({
  SourceAmount: '',
  SourceCurrency: '',
  BillNo: '',
  Email: '',
  Phone: '',
  Zip: '',
  Address: '',
  City: '',
  FirstName: '',
  LastName: '',
  CardNo: '',
  Cvv2: '',
  CardExpireMonth: '01',
  CardExpireYear: '2022',
  Country: '',
  State: '',
  abank: 0,
  mbank: 0,
  jbank: 0,
  vbank: 0,
})

provide('orderInfo', orderInfo)
const isMove = inject<boolean>('isMove') || false

onMounted(() => {
  const urlSearch = window.location.search
  if (urlSearch) {
    const orderId = urlSearch.substring(1)
    getOrderInfo(orderId, 2)
      .then((data) => {
        Object.assign(orderInfo, data)
      })
      .catch(() => {
        alert('Server Error')
      })
  } else {
    alert('Invalid order')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isMove) ? Move : Pc)))
}
}

})